import { Component, OnInit } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-share-org',
  templateUrl: './share-org.component.html',
  styleUrls: ['./share-org.component.scss'],
})
export class ShareOrgComponent {
  loader: boolean = true;
  org: any;
  maxlength ='10';
  id;
  numCd = '+91';
  data: any = [];
  items: any = [{ referralName: "", referralContactNbr: "", icon: 'add', referralEmail: "", numCd:"+91" }];
  msg;
  constructor(public service: ApiService, public handler: HandlerService, public router: Router, private bottomSheet: MatBottomSheet) { }
  async ionViewWillEnter() {
    this.id = window.location.href.split('/').pop();
    await this.service.getOrgAddressById(this.id).subscribe(res => {
      this.org = res;
      this.loader = false;
    },
      err => {
        this.loader = false;
        this.handler.err(err)
      });
    let url = window.location.href;

  }
  add() {
    var len = this.items.length;

    if (this.items[len - 1].referralContactNbr != "") {
      this.items.push({ referralName: "", referralContactNbr: "", icon: 'add', referralEmail: "", numCd:"+91" });
      // this.numCd.push("+61");
    }
    else {
      this.handler.res("Please Enter Required fields");
    }

  }
  addmore(data, i) {
    if (data.icon === "clear") {
      this.items.splice(i, 1);
    }
    else {
      this.items[i].icon = "clear";
      this.items.push({ referralName: "", referralContactNbr: "", icon: 'add', referralEmail: "", numCd:"+91" });
    }
  }
  
  save1(){
    let x=this.items.every(res=>res.referralContactNbr&&res.referralName);
      if(!x){
        this.handler.res("Please Enter Mobile Number,Name");
      }
      else{
        this.save();
      }
  }

  save() {
    this.loader = true
    let ref: any = [];
    this.items.map(res => {
      ref.push({
        referralName: res.referralName,
        referralContactNbr: this.numCd + res.referralContactNbr,
        referralEmail: res.referralEmail
      })
    })
    var post = {
      type: 1,
      referredOrgId: this.id,
      referrerUserId: localStorage.getItem('currentUserId'),
      message: this.msg,
      referrals: ref
    }
    this.service.postReferrals(post).subscribe(res => {
      this.loader = false;
      this.handler.res("Referral Added Successfully");
      this.router.navigate(['/refer-dash']);
    }, err => {
      this.handler.err(err);
      this.loader = false;
    })
  }


  checkMob(event) {
    event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    this.items.referralContactNbr = event.target.value;
  }

}


